"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.greyDark = exports.WRAPPER_PADDING = exports.WIDTH = exports.TEXT_WEB = exports.TEXT_MOB = exports.MOBILE_PADDING = exports.ICON_FONT_SIZE = exports.GRID_ROW_GAP = exports.DESKTOP_PADDING = exports.CLOSE_ICON = void 0;
var TEXT_WEB = 'All Other Categories';
exports.TEXT_WEB = TEXT_WEB;
var TEXT_MOB = 'All Categories';
exports.TEXT_MOB = TEXT_MOB;
var DESKTOP_PADDING = {
  TOP: '32px',
  BOTTOM: '24px',
  LEFT: '0px',
  RIGHT: '0px'
};
exports.DESKTOP_PADDING = DESKTOP_PADDING;
var MOBILE_PADDING = {
  TOP: '24px',
  BOTTOM: '22px',
  LEFT: '24px',
  RIGHT: '30px'
};
exports.MOBILE_PADDING = MOBILE_PADDING;
var GRID_ROW_GAP = '20px';
exports.GRID_ROW_GAP = GRID_ROW_GAP;
var greyDark = 'greyDark';
exports.greyDark = greyDark;
var WRAPPER_PADDING = '30px';
exports.WRAPPER_PADDING = WRAPPER_PADDING;
var WIDTH = '200px';
exports.WIDTH = WIDTH;
var CLOSE_ICON = 'CloseIcon';
exports.CLOSE_ICON = CLOSE_ICON;
var ICON_FONT_SIZE = 'titleNormal';
exports.ICON_FONT_SIZE = ICON_FONT_SIZE;